import { render, staticRenderFns } from "./StudyPlansTableActions.vue?vue&type=template&id=23542d5a&scoped=true&"
import script from "./StudyPlansTableActions.vue?vue&type=script&lang=js&"
export * from "./StudyPlansTableActions.vue?vue&type=script&lang=js&"
import style0 from "./StudyPlansTableActions.vue?vue&type=style&index=0&id=23542d5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23542d5a",
  null
  
)

export default component.exports